<ng-container *transloco="let t">
  <div class="d-flex flex-nowrap align-items-center share-buttons-wrapper justify-content-between">
    @if (isShareVisible) {
      <button shareButton="email" class="custom-share-button">
        <div class="d-flex flex-column align-items-center">
          <img src="/assets/icons/icons-alt/mail-alt.png" alt="Email"/>
          <span class="fs-14 pt-2 fw-normal">E-mail</span>
        </div>
      </button>
      <button shareButton="whatsapp" class="custom-share-button">
        <div class="d-flex flex-column align-items-center">
          <img src="/assets/icons/icons-alt/whatsapp-alt.png" alt="WhatsApp"/>
          <span class="fs-14 pt-2 fw-normal">WhatsApp</span>
        </div>
      </button>
      <button shareButton="facebook" class="custom-share-button">
        <div class="d-flex flex-column align-items-center">
          <img src="/assets/icons/icons-alt/facebook-alt.png" alt="Facebook"/>
          <span class="fs-14 pt-2 fw-normal">Facebook</span>
        </div>
      </button>
      <button shareButton="pinterest" class="custom-share-button">
        <div class="d-flex flex-column align-items-center">
          <img src="/assets/icons/icons-alt/pinterest-alt.png" alt="Pinterest"/>
          <span class="fs-14 pt-2 fw-normal">Pinterest</span>
        </div>
      </button>
    }
  </div>
  <div class="pt-4 d-flex flex-column justify-content-center">
    <p class="text-center">
      {{t('app.share.with.link')}} </p>
    <div class="pt-2">
      <div class="input-group">
        <input type="text" class="form-control" [value]="currentUrl" readonly>
        <span class="input-group-text cursor-pointer" (click)="copyToClipboard()">
          <img src="assets/icons/icons-alt/copy-alt.svg" alt="Copy">
        </span>
      </div>
    </div>
  </div>
</ng-container>
